import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=2aed24d4&scoped=true&"
var script = {}
import style0 from "./LoginIndex.vue?vue&type=style&index=0&id=2aed24d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed24d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aed24d4')) {
      api.createRecord('2aed24d4', component.options)
    } else {
      api.reload('2aed24d4', component.options)
    }
    module.hot.accept("./LoginIndex.vue?vue&type=template&id=2aed24d4&scoped=true&", function () {
      api.rerender('2aed24d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/components/LoginIndex.vue"
export default component.exports